import { render, staticRenderFns } from "./stage_staging_component.vue?vue&type=template&id=64dc1150&"
import script from "./stage_staging_component.vue?vue&type=script&lang=js&"
export * from "./stage_staging_component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "stage_staging_component.vue"
export default component.exports